<template>
    <SearchDetails/>
</template>
<script>
import SearchDetails from 'place/search/searchDetails.vue'
export default {
    components:{
      SearchDetails
    },
}
</script>
<style scoped>
</style>